import React from "react";
import SectionHeader from "./SectionHeader";
import { skills } from "../mock";
import * as Icons from "lucide-react";

const Skills = () => {
  return (
    <section id="skills" className="relative px-6 lg:px-10 py-20 border-t border-[#1c2533]">
      <div className="max-w-7xl mx-auto">
        <SectionHeader
          num="02 // CAPABILITY MATRIX"
          title="SKILLS & TOOLING"
          subtitle="OPERATIONAL // DETECTION // ANALYSIS"
        />
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {skills.map((sk, i) => {
            const Ico = Icons[sk.icon] || Icons.Shield;
            return (
              <div
                key={sk.domain}
                className="group relative border border-[#1c2533] bg-[#0c1118] p-6 card-hover"
              >
                <div className="flex items-center gap-3 mb-5 pb-4 border-b border-[#1c2533]">
                  <div className="w-10 h-10 grid place-items-center border border-[#2a3a52] bg-[#0a0e14] text-cyan-400 group-hover:border-cyan-400 transition-colors">
                    <Ico size={18} strokeWidth={1.5} />
                  </div>
                  <div>
                    <div className="font-mono text-[10px] tracking-[0.18em] text-slate-500">
                      MODULE_{String(i + 1).padStart(2, "0")}
                    </div>
                    <div className="font-mono font-semibold text-sm tracking-[0.1em] text-slate-100">
                      {sk.domain}
                    </div>
                  </div>
                </div>
                <div className="flex flex-wrap gap-1.5">
                  {sk.items.map((it) => (
                    <span
                      key={it}
                      className="font-mono text-[10.5px] tracking-[0.06em] text-slate-300 bg-[#0a0e14] border border-[#1c2533] px-2 py-1 rounded-sm hover:border-cyan-400 hover:text-cyan-400 transition-colors"
                    >
                      {it}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Skills;
